<section
  class="delivery-service-selection"
  data-testid="delivery-service-selection"
  [attr.aria-busy]="showDeliverySkeleton() || offeringsPending() ? 'true' : null"
>
  @if (showDeliverySkeleton()) {
    <output class="delivery-service-selection__status visually-hidden">
      {{ 'createShipment.serviceStep.deliveryService.loading' | translate }}
    </output>
    <app-delivery-service-skeleton />
  } @else if (!offeringsUnresolved()) {
    <header class="delivery-service-selection__header">
      <puro-typography
        component="h2"
        variant="h2"
        class="delivery-service-selection__title delivery-service-selection__title--desktop"
      >
        {{ 'createShipment.serviceStep.deliveryService.title' | translate }}
      </puro-typography>
      <puro-typography
        component="h2"
        variant="h2"
        align="center"
        class="delivery-service-selection__title delivery-service-selection__title--mobile"
      >
        {{ 'createShipment.serviceStep.deliveryService.titleMobile' | translate }}
      </puro-typography>
    </header>

    @if (loadState() === 'error') {
      <p
        class="delivery-service-selection__error"
        role="alert"
        data-testid="delivery-service-blocking-error"
      >
        {{ blockingErrorMessage() }}
      </p>
    }

    @if (loadState() === 'ready') {
      @if (couponWarning()) {
        <puro-alert severity="warning" data-testid="delivery-service-coupon-warning">
          {{
            'createShipment.serviceStep.deliveryService.errors.couponValidationFailed' | translate
          }}
        </puro-alert>
      }
      <div class="delivery-service-selection__matrix">
        <div
          class="delivery-service-selection__date-chips"
          role="group"
          data-testid="delivery-date-chips"
          [attr.aria-label]="
            'createShipment.serviceStep.deliveryService.dateChipsAriaLabel' | translate
          "
        >
          @for (column of columns(); track column.deliveryDate) {
            <puro-chip
              variant="filter"
              size="medium"
              color="primary"
              [label]="formatDateChipLabel(column.deliveryDate)"
              [selected]="activeDeliveryDate() === column.deliveryDate"
              (chipClick)="onSelectDeliveryDate(column.deliveryDate)"
            />
          }
        </div>

        <div
          class="delivery-service-selection__columns"
          role="group"
          [attr.aria-label]="
            'createShipment.serviceStep.deliveryService.matrixAriaLabel' | translate
          "
        >
          @for (column of columns(); track column.deliveryDate) {
            <app-delivery-date-column
              [class.delivery-date-column--inactive]="
                activeDeliveryDate() !== null && activeDeliveryDate() !== column.deliveryDate
              "
              [column]="column"
              [selectedProductCode]="selectedProductCode()"
              [fastestProductCode]="fastestProductCode()"
              [mostEconomicalProductCode]="mostEconomicalProductCode()"
              (offeringSelect)="onSelect($event)"
            />
          }
        </div>

        @if (showSelectionError()) {
          <p class="delivery-service-selection__selection-error" role="alert">
            {{ 'createShipment.serviceStep.deliveryService.errors.selectionRequired' | translate }}
          </p>
        }

        <app-service-legalese />
      </div>
    }
  }
</section>
